import React, { PureComponent, Fragment } from "react";
import {
  LoginCard,
  ButtonWrapper,
  Input,
  Form,
  Label,
  InputGroup,
  FormGroup,
  Button,
  LinkWrapper,
  FooterClass,
  ActionWrapper,
} from "../../authentication/styled";
import ErrorAlert from "../../components/error-alert/ErrorAlert";
import { LoginMode } from "../../authentication/login/LoginPage";

type ForgotPasswordProps = {
  username: string;
  userNameInput: any;
  handleInputChange: (event: any) => void;
  changeLoginMode: (loginMode: LoginMode, successfullySend?: boolean) => void;
  onForgotPassword: (event: any) => void;
  isFetching: boolean;
  showEmailSendSuccessfully: boolean;
  failureMessage?: string | null;
};

export default class ForgotPassword extends PureComponent<ForgotPasswordProps> {
  keyPressed = (event: any) => {
    if (event.key === "Enter") {
      this.props.onForgotPassword(event);
    }
  };

  render() {
    const {
      username,
      userNameInput,
      handleInputChange,
      changeLoginMode,
      onForgotPassword,
      isFetching,
      showEmailSendSuccessfully,
      failureMessage,
    } = this.props;
    return (
      <LoginCard>
        {showEmailSendSuccessfully ? (
          <Fragment>
            <div
              style={{
                color: "#fff",
                padding: "1.5rem 1rem 1rem 1rem",
                alignContent: "center",
                textAlign: "center",
                width: "100%",
              }}>
              <i
                className="fas fa-paper-plane"
                style={{ padding: "0.5rem 0 1rem 0", fontSize: "24px" }}></i>
              <p>
                The information to reset the password has been sent to the provided email address.
                If you do not receive an email, please check that you have supplied the correct
                email address.
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flex: "1 1 auto",
                alignItems: "flex-end",
                justifyContent: "center",
                padding: "2rem",
              }}>
              <LinkWrapper onClick={() => changeLoginMode(LoginMode.Login, true)}>
                Back To Login
              </LinkWrapper>
            </div>
          </Fragment>
        ) : (
          <Form autoComplete="off">
            <div style={{ minHeight: "150px", paddingBottom: "1rem" }}>
              <div style={{ color: "#fff", paddingBottom: "1rem" }}>
                Please enter the username associated with your account.
              </div>
              <FormGroup className="form-group">
                <InputGroup>
                  <Label>EMAIL</Label>
                  <Input
                    ref={userNameInput}
                    name="username"
                    type="text"
                    value={username}
                    aria-label="Username"
                    aria-describedby="username-icon"
                    required
                    autoFocus
                    onChange={handleInputChange}
                    onKeyPress={this.keyPressed}
                  />
                </InputGroup>
              </FormGroup>
            </div>
            {failureMessage && <ErrorAlert>{failureMessage}</ErrorAlert>}

            <FooterClass>
              <ActionWrapper>
                <LinkWrapper
                  onClick={() => changeLoginMode(LoginMode.Login)}
                  style={{ marginBottom: "1.8125rem" }}>
                  Back To Login
                </LinkWrapper>
                <ButtonWrapper>
                  <Button
                    type="button"
                    className="btn btn-primary"
                    onClick={(e: any) => onForgotPassword(e)}
                    disabled={username === ""}
                    style={{ marginBottom: "1.8125rem" }}>
                    {isFetching && (
                      <div
                        className="spinner-border spinner-border-sm"
                        style={{ marginRight: "0.5rem" }}
                        role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    )}{" "}
                    SUBMIT
                  </Button>
                </ButtonWrapper>
              </ActionWrapper>
            </FooterClass>
          </Form>
        )}
      </LoginCard>
    );
  }
}
